module.exports = __webpack_public_path__ + "static/img/hgd_mapBack.bbad5e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hgd_mapBack.png
// module id = Eytw
// module chunks = 1